class Functions{
    constructor() {
      this.baseUrl = 'http://localhost:5000/'; // Usar um enumerate
    }

    buildPieGraphParams(labels, dataset){
      const data = {
            labels: labels,
            datasets: [
              {
                data: dataset,
                backgroundColor: [
                  "#AF8500", // Dourado
                  "#0C0C0C", // Preto
                  "#A38D6D", // Bege acinzentado
                  "#F3E9D2", // Bege claro
                  "#8B6E3B", // Marrom claro
                  "#BBA277", // Tom areia
                  "#A58B63", // Bege escuro
                  "#D1B891", // Marrom areia
                  "#C2A473", // Amarelo queimado
                  "#9A7B4F", // Marrom dourado
                  "#E9D8B0", // Bege pastel
                  "#6E522A", // Marrom profundo
                  "#BDA38A", // Areia suave
                  "#C7A86E", // Dourado vintage
                  "#998158", // Mostarda queimado
                  "#D8C3A5", // Bege rosado
                  "#A37B4B", // Caramelo escuro
                  "#ECE2CE", // Branco areia
                ],
                hoverBackgroundColor: [
                  "#C29A00", // Dourado brilhante
                  "#222222", // Cinza escuro
                  "#B8A389", // Bege mais forte
                  "#F7EEDB", // Bege mais claro
                  "#9D7945", // Marrom médio
                  "#C5AF88", // Areia clara
                  "#B09470", // Bege médio
                  "#D9C2A3", // Marrom areia claro
                  "#D1B07D", // Amarelo terroso
                  "#A68256", // Dourado queimado
                  "#F2E3BA", // Bege iluminado
                  "#7C5C32", // Marrom escuro
                  "#CDB49A", // Bege natural
                  "#D1AF7B", // Dourado leve
                  "#A88F65", // Mostarda claro
                  "#E5D2BC", // Bege pálido
                  "#B28559", // Caramelo claro
                  "#F5F0E0", // Areia suave
                ],
              },
            ],
      };
      return data;
    }

    buildPieGraphParams2(result) {
      let labels, values;

      const value = result?.value;

      if (value && typeof value === 'object' && !Array.isArray(value)) {
        labels = Object.keys(value);
        values = Object.values(value);
      } else {
        console.warn("Dados inválidos para gráfico de pizza:", value);
        labels = ['Sem Registros'];
        values = [1];
      }
      const data = {
            labels: labels,
            datasets: [
              {
                data: values,
                backgroundColor: [
                  "#AF8500", // Dourado
                  "#0C0C0C", // Preto
                  "#A38D6D", // Bege acinzentado
                  "#F3E9D2", // Bege claro
                  "#8B6E3B", // Marrom claro
                  "#BBA277", // Tom areia
                  "#A58B63", // Bege escuro
                  "#D1B891", // Marrom areia
                ],
                hoverBackgroundColor: [
                  "#C29A00",
                  "#222222",
                  "#B8A389",
                  "#F7EEDB",
                  "#9D7945",
                  "#C5AF88",
                  "#B09470",
                  "#D9C2A3",
                ],
              },
            ],
      };
      return data;
    }

    buildBarGraphProdAgropecParams(prodAgropec){
          const labels = []
          const imoveis = []

          for (let [key, value] of Object.entries(prodAgropec)) {
            labels.push(key)
            imoveis.push(value.valor);
          }

          const data = {
            labels: labels,
            datasets: [
              {
                label: "Número de Imóveis",
                data: imoveis,
                backgroundColor: "rgba(175, 133, 0, 0.7)", // Cor dourada
                barThickness: 10,
                borderRadius: 0,
              },
            ],
          };
        return data;
    }

    buildSmallPieGraphParams(graphData){
      let labels, values;
      if (graphData) {
          labels = Object.keys(graphData.value);
          values = Object.values(graphData.value);

      } else {
          labels = ['Sem Registros'];
          values = [1];
      }
      const data = {
          labels: labels,
          datasets: [
            {
              data: values,
              backgroundColor: [
                "#0C0C0C", // Preto
                "#AF8500", // Dourado
              ],
              hoverBackgroundColor: [
                "#222222",
                "#C29A00",
              ],
            },
          ],
        };

      return data;
    }

    buildBarGraph(result, title){
      let labels, values;

      if (result) {
          labels = Object.keys(result.value);
          values = Object.values(result.value);

      } else {
          labels = ['Sem Registros'];
          values = [1];
      }

      const data = {
          labels: labels,
          datasets: [
            {
              label: title,
              data: values,
              backgroundColor: "#AF8500", // Cor dourada
              barThickness: 10,
              borderRadius: 0,
            },
          ],
      };

      return data;
    }

    getProprietarioParam(option, search){
      if(!search){
        return null;
      } else if (option === 'Nome do proprietário'){
        return search;
      } else {
        return null;
      }
    }

    getInscricaoParam(option, search){
      if(!search){
        return null;
      } else if (option === 'Nome do proprietário'){
        return null;
      } else {
        return search;
      }
    }

}
    // Exporta uma instância única (singleton)
    const apiInstance = new Functions();
    export default apiInstance;
